module.exports = __webpack_public_path__ + "static/media/flexibility.35e152f2.svg";